import React from "react";
import { ClipLoader } from "react-spinners";
import ReasonOfLotRejection from "./ReasonOfLotRejection";
import { useMediaQuery } from "react-responsive";
import ProductRejectedLot from "./ProductRejectedLot";
import ProductAcceptLot from "./ProductAcceptLot";

function ProductReportModelContent({
  isAccepted,
  acceptedOffers,
  rejectedOffers,
  setIsAcceptedModalOpen,
  setProceedAuctionReport,
  proceedAuctionReport,
  singleAuctionData,
  setReasonOfRejectionLots,
  reasonOfRejectionLots,
  handleSubmitAuctionReport,
  reportLoading,
}) {
  const isDastop = useMediaQuery({ query: "(max-width: 1550px)" });
  const offers = isAccepted ? acceptedOffers : rejectedOffers;
  const otherOffers = isAccepted ? rejectedOffers : acceptedOffers;

  const closeModal = (setModal) => setModal(false);
  return (
    <>
      <div className="valign-wrapper pin-top">

        <span
          className="material-symbols-outlined pointer select-label"
          onClick={() => {
            closeModal(
              setIsAcceptedModalOpen
            );
            setProceedAuctionReport(false);
          }}
          style={{ top: "-1.2rem", right: "-0.5rem" }}
        >
          close
        </span>
      </div>
      <div className={`flex column ${isDastop ? "gap-1 mt-1" : "gap-2 mt-1"}`}>
        {/* Show Reason of Rejection if Proceeded */}
        {proceedAuctionReport ? (
          <>
            {otherOffers.length > 0 && (
              <ProductRejectedLot
                rejectedOffers={otherOffers}
                offers={singleAuctionData?.offers}
              />
            )}
            <ReasonOfLotRejection
              setReasonOfRejectionLots={setReasonOfRejectionLots}
              reasonOfRejectionLots={reasonOfRejectionLots}
            />
          </>
        ) : (
          <>
            {offers.length > 0 && (
              <ProductAcceptLot
                acceptedOffers={offers}
                offers={singleAuctionData?.offers}
              />
            )}

            {otherOffers.length > 0 && (
              <ProductRejectedLot
                rejectedOffers={otherOffers}
                offers={singleAuctionData?.offers}
              />
            )}
          </>
        )}
      </div>
      <div className={`flex justify-center gap-1 ${isDastop ? "mt-1" : "mt-2"}`}>
        {proceedAuctionReport ||
          offers?.length === singleAuctionData?.offers?.length ? (
          <button
            className="green btn-small"
            disabled={
              reasonOfRejectionLots === "" &&
              offers?.length !== singleAuctionData?.offers?.length
            }
            onClick={() =>
              handleSubmitAuctionReport()
            }
          >
            {reportLoading ? <ClipLoader color="red" size={20} /> : "Submit"}
          </button>
        ) : (
          <button
            className="green btn-small"
            onClick={() => setProceedAuctionReport(true)}
          >
            Confirm & Proceed
          </button>
        )}
        {/* <button
          className="red btn-small modal-close"
          onClick={() => {
            closeModal(
              isAccepted ? setIsAcceptedModalOpen : setIsRejectedModalOpen
            );
            setProceedAuctionReport(false);
          }}
        >
          No
        </button> */}
      </div>
    </>
  );
}

export default ProductReportModelContent;
